import { Rpc } from '../rpc';
import { RpcOutbound } from '../rpc-outbound';
import { RpcOutboundClient } from '../rpc-outbound-client';
import { RpcCredSSPOperationResult, RpcCredSspResponseKey } from './rpc-credssp-model';

export class RpcCredSspResponseClient {
    /**
     * The CredSSP response command.
     *
     * @param rpc the rpc service.
     * @param data the CredSSP operation result object.
     * @param outbound the outbound channel to call. @optional
     * @return Promise<void> the promise object.
     */
    public static credSspResponse(rpc: Rpc, data: RpcCredSSPOperationResult): Promise<void>;
    public static credSspResponse(rpc: Rpc, data: RpcCredSSPOperationResult, outbound?: RpcOutbound): Promise<void>;
    public static credSspResponse(rpc: Rpc, data: RpcCredSSPOperationResult, outbound?: RpcOutbound): Promise<void> {
        if (outbound) {
            return RpcOutboundClient.callOutbound(
                rpc.rpcManager.rpcChannel,
                outbound,
                RpcCredSspResponseKey.command,
                RpcCredSspResponseKey.version,
                data
            );
        } else {
            return RpcOutboundClient.call(rpc, RpcCredSspResponseKey.command, RpcCredSspResponseKey.version, data);
        }
    }
}
